import {CREATE_FOOD_TYPE ,
    UPDATE_FOOD_TYPE ,
  DELETE_FOOD_TYPE ,
  FETCH_FOOD_TYPES,
 } from '../actions';

const initialState = {
selectedToDelete: null,
selectedToEdit: null,
setFoodType : null ,
updateFoodType : null,
foodTypes: [],
loading: false, 
updateFoodTypeError : null,
setFoodTypeError : null,
foodTypesError : null,
recentFoodTypesError : null,
selectedToDeleteError : null,
notifyFoodType : "false" ,
};

function foodTypeReducer(state = initialState, action) {
let selectedToDelete,
foodTypes,
updateFoodType,
setFoodType;

switch (action.type) {
  case `${CREATE_FOOD_TYPE}_PENDING`:
  case `${UPDATE_FOOD_TYPE }_PENDING`:  
  case `${FETCH_FOOD_TYPES}_PENDING`:
  case `${DELETE_FOOD_TYPE}_PENDING`:
    return { ...state, loading: true,
      selectedToDeleteError : null,
      foodTypesError : null,
      setFoodTypeError : null,
      updateFoodTypeError : null,
    };
   

  case `${CREATE_FOOD_TYPE}_FULFILLED`:
    setFoodType = action.payload.data;
      return { ...state, loading: false, setFoodType };
  case `${UPDATE_FOOD_TYPE}_FULFILLED`:
    updateFoodType = action.payload.data;
      return { ...state, loading: false, updateFoodType }; 
  case `${FETCH_FOOD_TYPES}_FULFILLED`:
    foodTypes = action.payload.data;
      return { ...state, loading: false, foodTypes };
   


  case `${DELETE_FOOD_TYPE}_FULFILLED`:
    selectedToDelete = action.payload.data;
    return { ...state, loading: false, selectedToDelete }; 

  case `${CREATE_FOOD_TYPE}_REJECTED`:
    return {...state, loading: false, setFoodTypeError: action.payload.response.data, state: initialState };
  case `${UPDATE_FOOD_TYPE}_REJECTED`:
    return {...state, loading: false, updateFoodTypeError: action.payload.response.data, state: initialState };
  case `${FETCH_FOOD_TYPES}_REJECTED`:
    return {...state, loading: false, foodTypesError: action.payload.response.data, state: initialState };
  case `${DELETE_FOOD_TYPE}_REJECTED`:
    return {...state, loading: false, selectedToDeleteError: action.payload.response.data, state: initialState };

  default:
    return state;
}
}

export default foodTypeReducer;
